export const ML_FINDINGS = [
  {
    actionDetails:
      '\nThis has a low risk appearance on imaging.\nIf asymptomatic, follow up typically is not needed and this can be assessed on follow up whole body MRI.\nIt is important to share this information if a future procedure is planned with your spine.',
    actionSummary: 'This is a variant of normal anatomy.',
    additionalRecommendations: null,
    aiAcknowledged: false,
    clinicalNotes: null,
    createdBy: 'auth0|ml_server',
    csdScore: 2,
    findingDetails:
      '\n There are 7 cervical, 12 thoracic rib bearing, and 5 lumbar type vertebrae visible.',
    findingSummary: 'There is a congenital nonstandard number of vertebrae in the spine.',
    keyImages: [],
    newFinding: true,
    oncoradsScore: 1,
    reportFindings: [
      {
        conditionDetail: [
          {
            name: 'number_of_c_spine_vertebrae',
            value: '7',
          },
          {
            name: 'number_of_t_spine_vertebrae',
            value: '12',
          },
          {
            name: 'number_of_l_spine_vertebrae',
            value: '5',
          },
        ],
        createdBy: 'auth0|ml_server',
        observation: '',
        status: 'draft',
        template: {
          condition: 'default_question_vertebrae_numbering',
          conditionDetail: [
            {
              name: 'number_of_c_spine_vertebrae',
              required: true,
              requiredWhen: null,
              showWhen: null,
              type: 'options',
              unit: '',
              value: ['6', '7'],
            },
            {
              name: 'number_of_t_spine_vertebrae',
              required: true,
              requiredWhen: null,
              showWhen: null,
              type: 'options',
              unit: '',
              value: ['10', '11', '12', '13'],
            },
            {
              name: 'number_of_l_spine_vertebrae',
              required: true,
              requiredWhen: null,
              showWhen: null,
              type: 'options',
              unit: '',
              value: ['4', '5', '6'],
            },
          ],
          normalStatementOutcome: {},
          organ: 'spine',
          uuid: 'c80e4f61-6c76-4750-a506-a24c3affdaa3',
        },
        templateUuid: 'c80e4f61-6c76-4750-a506-a24c3affdaa3',
        uuid: 'bc5fc7c8-bf47-474a-849a-f390a2d02344',
      },
    ],
    reportFindingsUuids: ['bc5fc7c8-bf47-474a-849a-f390a2d02344'],
    reportUuid: 'fbe0fd52-1bbf-4aac-b4aa-1f684c665c4f',
    status: 'draft',
    uuid: '7baf3aea-bd2f-4f64-a130-5dbc1bd8a059',
  },
  {
    actionDetails: '',
    actionSummary: '',
    additionalRecommendations: null,
    aiAcknowledged: false,
    clinicalNotes: null,
    createdBy: 'auth0|ml_server',
    csdScore: 1,
    findingDetails:
      '\nThe average volume of a normal size prostate is approximately 30 mL or less.',
    findingSummary: 'Your prostate volume was calculated to be 1 mL.',
    keyImages: [],
    newFinding: true,
    oncoradsScore: 1,
    reportFindings: [
      {
        conditionDetail: [
          {
            name: 'height',
            value: '2',
          },
          {
            name: 'width',
            value: '3',
          },
          {
            name: 'depth',
            value: '4',
          },
        ],
        createdBy: 'auth0|ml_server',
        observation: '',
        status: 'draft',
        template: {
          condition: 'default_question_total_size_of_prostate',
          conditionDetail: [
            {
              name: 'height',
              required: false,
              requiredWhen: {
                condition: {
                  condition: 'prostatectomy',
                  field: null,
                  value: null,
                },
                operator: 'not',
              },
              showWhen: null,
              type: 'number',
              unit: 'cm',
              value: null,
            },
            {
              name: 'width',
              required: false,
              requiredWhen: {
                condition: {
                  condition: 'prostatectomy',
                  field: null,
                  value: null,
                },
                operator: 'not',
              },
              showWhen: null,
              type: 'number',
              unit: 'cm',
              value: null,
            },
            {
              name: 'depth',
              required: false,
              requiredWhen: {
                condition: {
                  condition: 'prostatectomy',
                  field: null,
                  value: null,
                },
                operator: 'not',
              },
              showWhen: null,
              type: 'number',
              unit: 'cm',
              value: null,
            },
          ],
          normalStatementOutcome: {},
          organ: 'prostate',
          uuid: '9d9911be-2e72-4fc1-afc5-a908ac2082b4',
        },
        templateUuid: '9d9911be-2e72-4fc1-afc5-a908ac2082b4',
        uuid: '285488a4-d2f8-4aa8-95c3-586e58b8d8ef',
      },
    ],
    reportFindingsUuids: ['285488a4-d2f8-4aa8-95c3-586e58b8d8ef'],
    reportUuid: '150bce30-6a9d-48bb-881b-ec2cc28a9758',
    status: 'draft',
    uuid: '574cd46f-d0db-4d9e-8f8f-8f8387a25bdd',
  },
  {
    actionDetails: '',
    actionSummary: '',
    additionalRecommendations: '',
    aiAcknowledged: false,
    clinicalNotes: '',
    createdBy: 'auth0|ml_server',
    csdScore: 0,
    findingDetails: '',
    findingSummary: '',
    keyImages: [],
    newFinding: true,
    oncoradsScore: 0,
    reportFindings: [
      {
        conditionDetail: [
          {
            name: 'endometrial_thickness',
            value: '4',
          },
          {
            name: 'assess_endometrial_thickness',
            value: null,
          },
          {
            name: 'post_menopausal',
            value: null,
          },
        ],
        createdBy: 'auth0|ml_server',
        observation: '',
        status: 'draft',
        template: {
          condition: 'default_question_endometrial_thickness',
          conditionDetail: [
            {
              name: 'endometrial_thickness',
              required: false,
              requiredWhen: {
                condition: {
                  condition: 'default_question_endometrial_thickness',
                  field: 'assess_endometrial_thickness',
                  value: 'cannot be assessed',
                },
                operator: 'not',
              },
              showWhen: {
                condition: {
                  condition: 'default_question_uterus_appearance',
                  field: 'uterus_appearance',
                  value: 'absent',
                },
                operator: 'not',
              },
              type: 'number',
              unit: 'mm',
              value: null,
            },
            {
              name: 'assess_endometrial_thickness',
              required: false,
              requiredWhen: null,
              showWhen: {
                condition: {
                  condition: 'default_question_uterus_appearance',
                  field: 'uterus_appearance',
                  value: 'absent',
                },
                operator: 'not',
              },
              type: 'options',
              unit: '',
              value: ['cannot be assessed'],
            },
            {
              name: 'post_menopausal',
              required: false,
              requiredWhen: null,
              showWhen: {
                condition: null,
                operator: 'never',
              },
              type: 'bool',
              unit: '',
              value: null,
            },
          ],
          normalStatementOutcome: {},
          organ: 'uterus',
          uuid: 'd5c86dac-d473-4f3a-98ca-b6ebd1d9bfd2',
        },
        templateUuid: 'd5c86dac-d473-4f3a-98ca-b6ebd1d9bfd2',
        uuid: '1a0559a2-6729-47b9-a912-103d7282bc6f',
      },
    ],
    reportFindingsUuids: ['1a0559a2-6729-47b9-a912-103d7282bc6f'],
    reportUuid: '6d8fb5f8-fd54-4605-bdbb-a987526dda35',
    status: 'draft',
    uuid: 'd6029d27-4492-4935-9dd1-f3a206a84d29',
  },
  {
    actionDetails: '',
    actionSummary: '',
    additionalRecommendations: '',
    aiAcknowledged: false,
    clinicalNotes: '',
    createdAt: '2025-04-21T18:25:48.888094Z',
    createdBy: 'auth0|ml_server',
    csdScore: 1,
    findingDetails: '\n',
    findingSummary:
      'The uterus position is anteflexed, anteverted, hyperflexed, retroflexed, and retroverted.',
    keyImages: [],
    newFinding: true,
    oncoradsScore: 1,
    reportFindings: [
      {
        conditionDetail: [
          {
            name: 'uterus_appearance',
            value: ['anteflexed', 'anteverted', 'hyperflexed'],
          },
        ],
        createdAt: '2025-04-21T18:25:48.785787Z',
        createdBy: 'auth0|ml_server',
        observation: '',
        status: 'draft',
        template: {
          condition: 'default_question_uterus_appearance',
          conditionDetail: [
            {
              name: 'uterus_appearance',
              required: false,
              requiredWhen: null,
              showWhen: null,
              type: 'multiselect',
              unit: '',
              value: [
                'anteverted',
                'retroverted',
                'anteflexed',
                'retroflexed',
                'hyperflexed',
                'partially absent',
                'absent',
                'not visualized',
              ],
            },
          ],
          normalStatementOutcome: {},
          organ: 'uterus',
          uuid: '99b1147b-e851-45ac-bc2b-04a40a1dfdc8',
        },
        templateUuid: '99b1147b-e851-45ac-bc2b-04a40a1dfdc8',
        uuid: '757bc333-9574-4f29-9faa-e5f21dda7160',
      },
    ],
    reportFindingsUuids: ['757bc333-9574-4f29-9faa-e5f21dda7160'],
    reportUuid: 'cffdfe84-9ea4-4681-ad3d-74dff9ad3bdd',
    status: 'draft',
    uuid: '24dffa13-3c92-4d82-9e79-788fb2447013',
  },
];

export const ML_SERVER = 'auth0|ml_server';
